import sweetalert from 'sweetalert2'
import { AuthError } from '@kanbo/api'
import { runSaga } from 'store/sagaMiddleware'
import { init as initSaga } from 'store/sagas'
import { push } from 'index'

type Payload = {
  text?: string
  error?: any
  refresh?: boolean
}

const viewError = (payload: Payload) => async (dispatch, getState) => {
  const { text, error, refresh } = payload

  if (text) {
    try {
      await sweetalert({
        type: 'error',
        text
      })
    } catch (e) {}

    if (refresh) {
      runSaga(initSaga)
    } else {
      dispatch(push('/'))
    }
  } else if (error) {
    const state = getState()

    if (error instanceof AuthError) {
      try {
        await sweetalert({
          type: 'error',
          text: state.kanbo.locale.messages['AUTH_ERROR_INFO'],
          confirmButtonText: state.kanbo.locale.messages['AUTH_ERROR_RETRY'],
        })
      } catch (e) {}

      location.reload()

      return
    }

    try {
      const url = state.kanbo.config.errorReportingUrl

      let body = ''
      body += error.message
      body += '\n'
      if (error.requestArgs) {
        body += '*******************************************************************\n'
        body += '******************** Request info *********************************\n'
        body += '*******************************************************************\n'
        body += JSON.stringify(error.requestArgs)
        body += '\n'
      }
      if (error.stackTrace) {
        body += '*******************************************************************\n'
        body += '******************** Api stack trace ******************************\n'
        body += '*******************************************************************\n'
        body += error.message
        body += '\n'
        body += error.stackTrace
        body += '\n'
      }
      body += '*******************************************************************\n'
      body += '******************** App stack trace ******************************\n'
      body += '*******************************************************************\n'
      body += error.stack
      body += '\n'
      body += '*******************************************************************\n'
      body += '******************** Client info **********************************\n'
      body += '*******************************************************************\n'
      body += 'Url: ' + window.location.href
      body += '\n'
      body += 'UserAgent: ' + window.navigator.userAgent
      body += '\n'
      body += '*******************************************************************\n'
      body += '******************** KanBo info *********************************\n'
      body += '*******************************************************************\n'
      body += 'Version: ' + state.kanbo.version.version
      body += '\n'
      body += 'License name: ' + state.kanbo.license.name
      body += '\n'
      body += 'License expire: ' + new Date(state.kanbo.license.expireMax).toUTCString()
      body += '\n'
      body += 'License users: ' + state.kanbo.license.writersCurrent + '/' + state.kanbo.license.writersMax
      body += '\n'
      body += 'License light users: ' + state.kanbo.license.readersCurrent + '/' + state.kanbo.license.readersMax
      body += '\n'

      console.error(body)

      await sweetalert({
        type: 'error',
        showCancelButton: true,
        confirmButtonText: state.kanbo.locale.messages['ERROR_SEND'],
        cancelButtonText: state.kanbo.locale.messages['CLOSE'],
        text: state.kanbo.locale.messages['ERROR_INFO']
      })

      // Send Error

      const sendMail = () => {
        let href = `mailto:support@kanbozone.com?subject=KanBo Error&body=${error.message}`
        if (error.stackTrace) href += ` ${error.stackTrace}`
        href += ` ${error.stack}`

        window.location.href = href
      }

      if (url) {
        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            header: error.message || 'No error message',
            body
          })
        }).then((res) => {
          if (!res.ok) {
            throw res
          }
        }).catch((res) => {
          console.error(res)

          sendMail()
        })
      } else {
        sendMail()
      }
    } catch (e) {
      // Close
    }

    if (refresh) {
      runSaga(initSaga)
    } else {
      dispatch(push('/'))
    }
  }
}

export default viewError
